import { FractalSDKError, FractalSDKTransactionStatusFetchUnknownError, } from "../../core/error/index.js";
import { useTransactionStatusPoller } from "../../queries/transaction.js";
import { useCallback } from 'react';
import { TransactionStatus } from "../../types/index.js";
export const useWaitForTransactionStatus = () => {
    const pollForTransactionStatus = useTransactionStatusPoller();
    const waitForTransactionStatus = useCallback(async (signature) => {
        try {
            const success = await pollForTransactionStatus(signature);
            if (success) {
                return TransactionStatus.SUCCESS;
            }
            return TransactionStatus.FAIL;
        }
        catch (err) {
            if (err instanceof FractalSDKError) {
                throw err;
            }
            throw new FractalSDKTransactionStatusFetchUnknownError('An unknown error occured while fetching the status of a signature');
        }
    }, [pollForTransactionStatus]);
    return {
        waitForTransactionStatus,
    };
};
//# sourceMappingURL=use-wait-for-transaction-status.js.map